import { Member } from "domain-entities";

interface CompanyMembers {
	[email: string]: Member;
}

export interface ValidMember extends Member {
	id: string;
}

export function getValidMembers(membersObject?: CompanyMembers) {
	if (membersObject) {
		return Object.keys(membersObject)
			.map((key) => membersObject[key])
			.reduce<ValidMember[]>((result, member) => {
				if (isValidMember(member)) {
					result.push(member);
				}

				return result;
			}, [])
			.sort((a, b) => {
				const aName = `${a.name || ""} ${a.lastname || ""}`.trim();
				const bName = `${b.name || ""} ${b.lastname || ""}`.trim();

				return aName.localeCompare(bName);
			});
	} else {
		return [];
	}
}

export function isValidMember(member: Member): member is ValidMember {
	return !!member.id && member.inviteState === "ACCEPTED";
}

export function displayEmployeeName(member: ValidMember): string {
	if (member.name && member.lastname) {
		return `${member.lastname}, ${member.name}`;
	}
	return member.email;
}
